'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import MailingListController from './mailinglist.component';
import MailingListService from '../../app/cart/mailinglist.service';
export default angular.module('directives.mailinglist', [ngMaterial])
    .controller('MailingListController', MailingListController)
    .component('mailinglist', {
    template: require('./mailinglist.html'),
    controller: MailingListController
})
    .service('MailingListService', MailingListService)
    .name;
//# sourceMappingURL=index.js.map